{
    "user-app-guide": {
        "title": "User App Guide",
        "headers": {
            "title": "Title",
            "titleGR": "Greek Title",
            "content": "Content",
            "contentGR": "Greek Content",
            "subtitle": "Subtitle",
            "subtitleGR": "Greek Subtitle",
            "image": "Image",
            "status": "Status",
            "actions": "Actions"
        },
        "DRAFT": "Draft",
        "PUBLISHED": "Published"
    },
    "Activity": "Activity",
    "Created At": "Created At",
    "Updated At": "Updated At",
    "actions": "Actions",
    "global": {
        "yes": "Yes",
        "no": "No",
        "firstName": "First Name",
        "search-text": "Search Keyword",
        "query-methods": {
            "raw": "Raw",
            "sum": "Aggregated",
            "median": "Mean",
            "min": "Minimum",
            "max": "Maximum",
            "mean": "Average"
        },
        "resolution-types": {
            "seconds": "Seconds",
            "minutes": "Minutes",
            "hours": "Hours",
            "days": "Days",
            "weeks": "Weeks",
            "months": "Months",
            "years": "Years"
        },
        "records": "Records",
        "record": "Record",
        "no-data-available": "No Data Available",
        "showing": "Showing",
        "to": "to",
        "of": "of",
        "more": "more",
        "device-connected": "Connected",
        "device-disconnected": "Disconnected",
        "devices-connected": "Connected",
        "devices-disconnected": "Disconnected"
    },
    "headers": {
        "location-name": "Location",
        "tenant-name": "Tenant",
        "isEnabled": "Enabled",
        "macAddress": "Mac Address",
        "name": "Name",
        "address": "Address",
        "device-type": "Device Type",
        "description": "Description",
        "type": "Type",
        "AssignmentToken": "Assignment Token"
    },
    "device-groups": "Device Groups",
    "tree": {},
    "name": "Name",
    "isActive": "Condition",
    "repeat-Period": "Repeat Period",
    "title": "Title",
    "started-Day": "Starting Day",
    "status": "Status",
    "description": "Description",
    "startsWith": "Starts with",
    "contains": "Contains",
    "type": "Type",
    "action": "Action",
    "variables": "Variables",
    "notContains": "Not contains",
    "updatedAt": "Updated At",
    "createdAt": "Created At",
    "endsWith": "Ends with",
    "equals": "Equals",
    "notEquals": "Not equals",
    "noFilter": "No Filter",
    "lt": "Less than",
    "lte": "Less than or equal to",
    "gt": "Greater than",
    "gte": "Greater than or equal to",
    "is": "Is",
    "isNot": "Is not",
    "before": "Before",
    "after": "After",
    "dateIs": "Date is",
    "dateIsNot": "Date is not",
    "dateBefore": "Date is before",
    "dateAfter": "Date is after",
    "clear": "Clear",
    "apply": "Apply",
    "matchAll": "Match All",
    "matchAny": "Match Any",
    "addRule": "Add Rule",
    "removeRule": "Remove Rule",
    "accept": "Yes",
    "reject": "No",
    "choose": "Choose",
    "upload": "Upload",
    "cancel": "Cancel",
    "dayNames": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    "dayNamesShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    "dayNamesMin": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    "monthNames": [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    "monthNamesShort": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    "firstDayOfWeek": 0,
    "today": "Today",
    "weekHeader": "Wk",
    "weak": "Weak",
    "medium": "Medium",
    "strong": "Strong",
    "passwordPrompt": "Enter a password",
    "emptyMessage": "No results found",
    "emptyFilterMessage": "No results found",
    "Number": "Number",
    "Email": "Email",
    "Phone": "Phone",
    "Actions": "Actions",
    "Users": "Users",
    "errors": {
        "error": "Error",
        "user": {
            "verificationFailed": "Email verification failed. Please try again.",
            "subscription": "User Subscription Error",
            "loadData": "Unable to load user data.",
            "updateFailed": "User update failed. Please try again.",
            "loginFailed": "Login Failed.",
            "invalidCredentials": "Invalid credentials",
            "fetchFailed": "Failed to fetch user information.",
            "notFound": "User not found.",
            "unauthorized": "You are not authorized to view this user information.",
            "creationFailed": "User creation failed.",
            "deletionFailed": "User deletion failed."
        },
        "roles": {
            "rolesLoadingFailed": "There was a problem loading the roles",
            "invalidSelection": "Invalid role selection. Please select a valid role."
        },
        "token": {
            "expired": "The verification link has expired.",
            "missing": "No verification token provided."
        },
        "network": {
            "timeout": "Network Timeout Error",
            "disconnected": "You are not connected to the internet.",
            "serverError": "An error occurred while verifying your account.",
            "loginAuthentication": "You are not authorized to access this application."
        },
        "form": {
            "required": "This field is required",
            "emailInvalid": "Email is not valid",
            "maxLength": "The field cannot exceed {max} characters.",
            "validationError": "Validation Error",
            "checkInput": "Please check your input",
            "passwordMismatch": "Passwords do not match."
        },
        "passwordReset": {
            "unableToReset": "Unable to reset password. Please try again later."
        },
        "registration": {
            "registrationFailed": "Registration Failed",
            "tryAgainLater": "Unable to complete registration. Please try again later."
        },
        "resetPassword": {
            "passwordChangeFailedMessage": "Password change failed",
            "newPasswordLabel": "New Password",
            "confirmNewPasswordLabel": "Confirm New Password",
            "changePasswordButton": "Change Password"
        },
        "createPassword": {
            "passwordCreationFailedMessage": "There was an error creating your password. Please try again."
        },
        "sidebar": {
            "unableToLoad": "Unable to load sidebar items."
        }
    },
    "validation": {
        "required": "This field is required",
        "email": "Please enter a valid email address",
        "passwordStrength": "Your password does not meet the required strength",
        "mismatch": "Passwords do not match",
        "passwordStrengthValidation": {
            "upperCase": "The password must contain uppercase characters",
            "lowerCase": "The password must contain lowercase characters",
            "number": "The password must contain numeric characters",
            "special": "The password must contain special characters",
            "minLength": "The password must be at least 8 characters long."
        }
    },
    "success": {
        "emailVerified": "Email verified successfully",
        "passwordResetRequested": "We've sent you an email with password reset instructions.",
        "checkYourEmail": "Please check your email for the reset instructions and follow them to regain access.",
        "verificationSuccess": "Your account has been successfully verified.",
        "registrationSuccessful": "Registration Successful",
        "checkEmail": "Please check your email to verify your account before logging in.",
        "passwordChangeSuccess": "Success",
        "passwordChangeSuccessMessage": "Your password has been successfully changed",
        "rolesLoadedSuccessfully": "Roles loaded successfully",
        "roleUpdated": "Role '{role}' updated successfully.",
        "userCreated": "User created successfully.",
        "userUpdated": "User updated successfully.",
        "userDeleted": "User deleted successfully.",
        "tenantCreated": "Tenant created successfully.",
        "tenantUpdated": "Tenant updated successfully.",
        "tenantDeleted": "Tenant deleted successfully.",
        "userRemovedFromTenant": "User removed from tenant successfully.",
        "specificationCreated": "Specification created successfully.",
        "specificationUpdated": "Specification updated successfully.",
        "specificationDeleted": "Specification deleted successfully.",
        "specificationSpecCreated": "Specification Spec created successfully.",
        "specificationSpecUpdated": "Specification Spec updated successfully.",
        "specificationSpecDeleted": "Specification Spec deleted successfully.",
        "locationCreated": "Location created successfully.",
        "locationUpdated": "Location updated successfully.",
        "locationDeleted": "Location deleted successfully.",
        "subLocationCreated": "Sublocation created successfully.",
        "subLocationUpdated": "Sublocation updated successfully.",
        "subLocationDeleted": "Sublocation deleted successfully.",
        "subLocationExpanded": "Sublocation expanded",
        "subLocationCollapsed": "Sublocation collapsed",
        "gatewayCreated": "Gateway created successfully.",
        "gatewayUpdated": "Gateway updated successfully.",
        "gatewayDeleted": "Gateway deleted successfully.",
        "deviceCreated": "Device created successfully.",
        "deviceUpdated": "Device updated successfully.",
        "deviceDeleted": "Device deleted successfully.",
        "passwordCreationSuccess": "Password Successfully Created",
        "passwordCreationSuccessMessage": "Your password has been successfully created.",
        "success": "Success",
        "guideCreated": "Post created successfully.",
        "guideUpdated": "Post updated successfully.",
        "guideDeleted": "Post deleted successfully."
    },
    "warnings": {
        "warning": "Warning",
        "noMatchingTenant": "No matching tenant found. Please check your input.",
        "tenantsArrayEmpty": "No tenants available. Please ensure tenants are properly configured."
    },
    "login": {
        "title": "Login",
        "hello": "Hello,",
        "noAccount": "Don't have an account?",
        "createToday": "Create today!",
        "rememberMe": "Remember Me",
        "forgotPassword": "Forgot Password?",
        "signIn": "Sign In",
        "tryAgainMessage": "or you can try to log in again."
    },
    "forgetPassword": {
        "title": "Forget Password",
        "enterEmailToReset": "Enter your email to reset your password",
        "emailSentTitle": "Email Sent Successfully!",
        "checkInbox": "Check your inbox for the password reset instructions.",
        "checkSpam": "If you do not receive an email, make sure to check your spam folder.",
        "logInAccount": "Log in to your account",
        "newPasswordRequest": "You can request a new password reset link in:",
        "requestPasswordReset": "Reset My Password",
        "emailAlreadySent": "Email already sent, please check your inbox.",
        "emailSentConfirmation": "A password reset email has already been sent to your email address.",
        "checkInboxReminder": "Μake sure to check your spam folder."
    },
    "signup": {
        "title": "Register",
        "haveAccount": "Do you have an account?",
        "firstName": "First Name",
        "firstNamePlaceholder": "Enter your first name",
        "lastName": "Last Name",
        "lastNamePlaceholder": "Enter your last name",
        "confirmPassword": "Confirm Password",
        "confirmPasswordPlaceholder": "Re-enter your password",
        "registerButton": "Register"
    },
    "emailVerification": {
        "missingToken": "Missing Token",
        "resetLinkExpired": "Reset Link Expired",
        "resetLinkExpiredRetry": "Please request a new password reset link.",
        "goToLoginBtn": "Go to Login",
        "congratulations": "Congratulations!",
        "navigateLogin": "You can navigate to login page"
    },
    "resetPassword": {
        "resetLinkExpired": "Reset Link Expired",
        "retryResetLink": "If you did not receive an email, check your spam folder or try requesting a new reset link.",
        "doYouHaveAccount": "Do you have an account?",
        "loginToAccount": "Login to your account!",
        "resetPassword": "Reset Password",
        "setNewPassword": "Please set a new password for your account.",
        "passwordChangedSuccessfully": "Password Successfully Changed",
        "passwordChangedSuccess": "Your password has been successfully changed.",
        "loginWithNewPassword": "You can now log in with your new password.",
        "newPassword": "New Password",
        "confirmNewPassword": "Confirm New Password",
        "changePassword": "Change Password"
    },
    "createPassword": {
        "createLinkExpired": "Create New Password Link Expired",
        "retryCreateLink": "If you did not receive an email, check your spam folder or try requesting a new create password link.",
        "createNewPassword": "Create New Password",
        "pleaseCreateNewPassword": "Please create a new password for your account",
        "passwordSuccessfullyCreated": "Password Successfully Created",
        "passwordHasBeenSuccessfullyCreated": "Your password has been successfully created"
    },
    "setPassword": {},
    "commonAuth": {
        "back": "Back",
        "emailLabel": "Email",
        "logIn": "Log in",
        "loading": "Loading",
        "logInAccount": "Log in to your account",
        "emailPlaceholder": "Enter your email",
        "passwordLabel": "Password",
        "passwordPlaceholder": "Enter your password",
        "showPassword": "Show password",
        "hidePassword": "Hide password",
        "unauthorizedAccess": "You are not authorized to access this application.",
        "unauthorizedDetail": "If you believe this is a mistake, please contact your administrator,",
        "cancel": "Cancel"
    },
    "user": {
        "admin": "Admin",
        "end-user": "End User",
        "role": "Role",
        "activity": "Activity",
        "createUser": "Create User",
        "isActive": "isActive",
        "save": "Save"
    },
    "sidebar": {
        "preferencesTitle": "Preferences",
        "darkMode": "Dark Mode",
        "header": {
            "subMenu": {
                "account": "Account",
                "logout": "Logout"
            }
        }
    },
    "default_sub_label_key": "Default Sub-Item",
    "home": {
        "title": "Home",
        "test": "this is home!"
    },
    "dashboard": {
        "title": "Dashboard"
    },
    "common": {
        "user": "User"
    },
    "commonAction": {
        "goBack": "Go Back",
        "retryLogin": "Try Again"
    },
    "administrator": {
        "title": "Administrator"
    },
    "support": {
        "title": "Support",
        "search": "Search",
        "email-required": "Email is required",
        "email-valid": "Invalid email format",
        "connected": "Connected",
        "details": "Details"
    },
    "smartips-news": {
        "title": "Smart Tips and News"
    },
    "support-page": {
        "title": "Support Page"
    },
    "explore": {
        "title": "Explore",
        "execute": "Execute"
    },
    "admin": {
        "tabs": {
            "users": "Users",
            "tenants": "Tenants",
            "locations": "Locations",
            "devices": "Devices",
            "device-groups": "Device Groups",
            "specifications": "Specifications",
            "gateways": "Gateways",
            "assets": "Assets"
        },
        "users": {
            "firstName": "First Name",
            "lastName": "Last Name",
            "phone": "Phone",
            "email": "Email",
            "roles": "Roles",
            "active": "Active",
            "inactive": "InActive",
            "userId": "UserId",
            "roleId": "RoleId",
            "sortBy": "Sort By",
            "update": "Update",
            "reset": "Reset",
            "change": "Change Password"
        },
        "device-groups": {
            "title": "Device Groups",
            "group": "Group",
            "create-group": "Create Group",
            "update-group": "Update Group",
            "view-group": "View Group",
            "delete-group": "Delete Group"
        },
        "tenants": {
            "confirmDelete": "Are you sure you want to Delete Tenant: ",
            "tenantDialogHeader": {
                "update": "Edit Tenant",
                "create": "Create Tenant",
                "view": "View Tenant",
                "delete": "Delete Tenant"
            }
        },
        "locations": {
            "form": {
                "adminUser": "Admin User",
                "baseUsers": "Base Users",
                "tenantName": "Tenant Name",
                "addBaseUser": "Add a Base User",
                "changeSiteManager": "Change Site Manager",
                "selectUser": "Select User",
                "address": "Address",
                "locationlng": "Longitude",
                "locationlat": "Latitude",
                "fieldIsRequired": "Field is required.",
                "description": "Description",
                "confirmDelete": "Are you sure you want to Delete Location: ",
                "location": "Location",
                "create-location": "Create Location",
                "update-location": "Update Location",
                "view-location": "View Location",
                "delete-location": "Delete Location"
            }
        },
        "sublocations": {
            "form": {
                "confirmDelete": "Are you sure you want to Delete Sublocation: "
            }
        },
        "user": {
            "users": "Users",
            "selectRoles": "Select Roles",
            "selectRole": "Select Role",
            "noRole": "No Role",
            "form": {
                "confirmDelete": "Are you sure you want to Delete User: ",
                "fieldIsRequired": "Field is required.",
                "token": "Token",
                "tenant": "Tenant",
                "user": "User",
                "selectUser": "Select User"
            },
            "addUser": "Add User",
            "editThisUser": "<b>Edit</b> this User",
            "deleteThisUser": "<b>Delete</b> this User",
            "usersInOrder": "Set the <b>users</b> in order"
        },
        "userDialogHeaders": {
            "update": "Edit User",
            "create": "Create User",
            "view": "View User",
            "delete": "Delete User"
        }
    },
    "dateRangeSelector": {
        "customPeriod": "Custom Period:",
        "startDate": "Start Date",
        "endDate": "End Date",
        "today": "Today",
        "yesterday": "Yesterday",
        "thisWeek": "This Week",
        "thisMonth": "This Month",
        "last7Days": "Last 7 Days",
        "last30Days": "Last 30 Days",
        "lastWeek": "Last Week",
        "lastMonth": "Last Month",
        "last3Months": "Last 3 Months",
        "selectPeriodPlaceholder": "Select a Period",
        "apply": "Apply",
        "clear": "Clear",
        "reset": "Reset",
        "dateFormat": "MM/dd/yyyy HH:mm",
        "validationErrorMessage": "Please ensure all date fields are correctly filled.",
        "successMessage": "Date range successfully applied.",
        "notifications": {
            "warning": "Warning",
            "success": "Success"
        },
        "selectedDateRange": "Selected Date Range",
        "clearDates": "Clear Dates"
    },
    "ac_enums": {
        "action": {
            "mode": "Mode",
            "airflow": "Airflow",
            "temperature": "Temperature"
        },
        "mode": {
            "off": "Off",
            "auto": "Auto",
            "cool": "Cool",
            "heat": "Heat",
            "fanonly": "Fan",
            "dry": "Dry"
        },
        "airflow": {
            "weak": "Weak",
            "medium": "Medium",
            "strong": "Strong",
            "auto": "Auto"
        },
        "temperature": {
            "celsius": "Celsius",
            "fahrenheit": "Fahrenheit",
            "heatTemperature": "Heat",
            "coolTemperature": "Cool"
        }
    },
    "devices": {
        "AreaSensor": "Area Sensor",
        "DoorWindowSensor": "Door Window Sensor",
        "Thermostat": "Thermostat",
        "Plug": "Plug",
        "Lamp": "Lamp",
        "Relay": "Water Heater",
        "PowerMeter": "Power Meter",
        "AC": "Air Conditioner",
        "plug": "Plug",
        "bulb": "Bulb",
        "relay": "Relay",
        "thermostat": "Thermostat",
        "device": " Device",
        "loading": "Applying changes",
        "lastUpdated": "Last updated",
        "gateways": "Gateways",
        "totalRecords": "records",
        "select": {
            "actuation-type": "Select a Device Actuation Type",
            "device": "Select  a Device",
            "action": "Select an Action",
            "variable": "Select a Variable",
            "operator": "Select an Operation",
            "value": "Add a number"
        },
        "success": {
            "modeUpdated": "Mode updated successfully.",
            "airflowUpdated": "Airflow updated successfully.",
            "temperatureUpdated": "Temperature updated successfully.",
            "true": "{{deviceName}} successfully Activated",
            "false": "{{deviceName}} successfully Closed",
            "groupCreated": "Device group created successfully",
            "groupUpdated": "Device group updated successfully",
            "groupDeleted": "Device group deleted successfully"
        },
        "notifications": {
            "dataError": "No data available for the AC settings.",
            "connectionError": "Error in data subscription."
        },
        "actions": {
            "retry": "Attempting to reconnect. Attempt #{count}: retrying in {time} milliseconds.",
            "isActive": "Is Active",
            "searchKeyword": "Search keyword",
            "records": "Records"
        },
        "error": {
            "invalidMode": "Selected mode is not valid.",
            "invalidAirflow": "Selected airflow is not valid.",
            "invalidTemperature": "Selected temperature control is not valid.",
            "acModeError": "Failed to change Mode",
            "airFlowError": "Failed to change Airflow",
            "acTemperatureError": "Failed to change Temperature",
            "dataError": {
                "summary": "Data Error",
                "detail": "No data available for the AC settings."
            },
            "connectionError": "Connection error:",
            "subscriptionError": "Error in data subscription:",
            "error": "Error",
            "serializationError": "There was an error in preparing the data for transmission.",
            "true": "Failed to activate {{deviceName}}",
            "false": "Failed to close {{deviceName}}",
            "loadError": "Failed to load device groups or user data"
        },
        "ariaLabels": {
            "airflowIntensitySlider": "Airflow Intensity Slider",
            "heatingTemperatureSlider": "Heating Temperature Slider",
            "coolingTemperatureSlider": "Cooling Temperature Slider"
        },
        "legends": {
            "airflowIntensity": "Airflow Intensity",
            "heatingTemperature": "Heating Temperature",
            "coolingTemperature": "Cooling Temperature"
        },
        "statusLabel": "Status",
        "status": {
            "connected": "Connected",
            "disconnected": "Disconnected",
            "Home": {
                "success": "{{deviceName}} Mode  Home",
                "error": "{{deviceName}} Mode Failed to Update"
            },
            "Away": {
                "success": "{{deviceName}} Mode  Away",
                "error": "{{deviceName}} Mode Failed to Update"
            }
        },
        "hotwater": {
            "true": {
                "success": "Hot Water activated",
                "error": "Hot Water Failed to change"
            },
            "false": {
                "success": "Hot Water closed",
                "error": "Hot Water Failed to change"
            }
        },
        "thermostatPower": {
            "success": "Thermostat status changed",
            "error": "Failed to change Thermostat status"
        },

        "temperature": {
            "success": "Temperature successfully Updated",
            "error": "Temperature failed to Update"
        },
        "connectionStatus": {
            "tryingToConnect": "Trying to connect to the device...",
            "failedToConnect": "Failed to connect. Please try again.",
            "connected": "Device connected.",
            "disconnected": "Device disconnected.",
            "retry": "Retrying to connect to the device...",
            "retryFailed": "Failed to reconnect to the device. Please try again.",
            "stableSubscriptionFailed": "Failed to establish a stable subscription after retries.",
            "unknown": "Unknown connection status."
        },
        "operations": {
            "confirmDelete": "Are you sure you want to Delete Device: ",
            "deleteSelectedGateway": "Delete the selected gateway",
            "editSelectedGateway": "Edit the selected gateway",
            "viewSelectedGatewayDetails": "View details of the selected gateway",
            "changeSelectedGatewaySettings": "Change settings of the selected gateway",
            "unpairAllDevicesFromSelectedGateway": "Unpair all devices from the selected gateway",
            "pairNewDeviceWithSelectedGateway": "Pair a new device with the selected gateway",
            "pairingInProgress": "Pairing in progress, please wait",
            "noRecordsFound": "No records found",
            "operationFailed": "Operation Failed",
            "anErrorOccurred": "An error occurred",
            "deletion": {
                "processBegun": "Deletion process has begun",
                "processStartedFor": "Deletion process has started for",
                "completed": "Deletion completed",
                "noDevicesFoundFor": "No devices found to delete for",
                "initiated": "Deletion initiated",
                "initiatedFor": "Deletion initiated for",
                "failedFor": "Deletion failed for",
                "failed": "Deletion failed",
                "noMacAddress": "No MAC address found for the gateway device."
            },
            "pairing": {
                "processBegun": "Pairing process has begun",
                "processStartedFor": "Pairing process has started for",
                "initiated": "Pairing initiated",
                "initiatedFor": "Pairing initiated for",
                "failedFor": "Pairing failed for",
                "completed": "Pairing completed",
                "failed": "Pairing failed",
                "errorDuring": "Error during pairing:",
                "invalidDataReceived": "Invalid data received during pairing.",
                "pairedDevices": "Paired Devices",
                "pairedDevicesHeader": "Paired Devices:",
                "noPairedDevicesFound": "No paired devices found"
            },
            "fetchDevices": {
                "failedFor": "Failed to fetch devices for"
            },
            "confirmation": {
                "title": "Delete Paired Devices",
                "deleteAllPairedDevices": " <center> Are you sure you want to delete all paired devices? <br> This action cannot be undone. </center>",
                "rejectedTitle": "Deletion Rejected",
                "rejectedMessage": "You have cancelled the deletion of paired devices."
            },
            "actions": {
                "accept": "Accept",
                "reject": "Reject"
            }
        },
        "deviceGroups": {
            "selectLocation": "Select a location to view available groups!",
            "selectedDevices": "Selected Devices",
            "availableDevices": "Available Devices",
            "groupName": "Νame",
            "groupPlaceholderName": "set a name for the group",
            "groupDescription": "Description",
            "groupPlaceholderDescription": "set a description for the group",
            "user": "User",
            "groupPlaceholderUser": "set a user for the group",
            "groupIcon": "Icon",
            "groupPlaceholderIcon": "set an icon for the group",
            "confirmDelete": "Are you sure you want to Delete Device Group: ",
            "columns": {
                "id": "ID",
                "icon": "Icon",
                "name": "Name",
                "userEmail": "User",
                "description": "Description",
                "actions": "Actions",
                "createdAt": "Created At",
                "updatedAt": "Updated At"
            }
        },
        "ai": {
            "singlePhaseHeatPump": "Single Phase Heat Pump",
            "threePhaseHeatPump": "Three Phase Heat Pump",
            "waterHeater": "Water Heater",
            "oven": "Oven",
            "microwaveOven": "Microwave Oven",
            "washingMachine": "Washing Machine",
            "dryer": "Dryer",
            "dishwasher": "Dishwasher",
            "fridge": "Fridge",
            "toaster": "Toaster",
            "coffeeMachine": "Coffee Machine"
        },
        "gateway": {
            "update": "Update",
            "gatewayManagement": "Gateway Management",
            "macAddress": "Mac Address",
            "serialNumber": "Serial Number",
            "enabled": "Enabled",
            "yes": "Yes",
            "no": "No",
            "owner": "Owner",
            "created": "Created",
            "lastUpdate": "Last Update",
            "availability": "Availability",
            "pairing": "Pairing",
            "reset": "Reset",
            "sync": "Sync"
        },
        "measurement": {
            "labels": {
                "temperature": "Temperature",
                "humidity": "Humidity",
                "luminance": "Lumiance",
                "status": "Status",
                "time": "Time",
                "last-movement": "Last detection",
                "low-battery": "Low battery",
                "setpoint": "Setpoint",
                "mode": "Mode",
                "hot-water": "Hot water",
                "energy": "Energy",
                "power": "Power",
                "airflow": "Airflow",
                "heat-temp": "Heat Temperature",
                "cool-temp": "Cold Temperature",
                "brightness": "Brightness",
                "color-temperature": "Color temperature",
                "color": "Color"
            },
            "values": {
                "open": "Open",
                "closed": "Closed",
                "on": "on",
                "off": "off",
                "home": "Home",
                "away": "Away"
            }
        }
    },
    "units": {
        "celsius": "°C",
        "percent": "%"
    },
    "buttons": {
        "save": "Save",
        "cancel": "Cancel",
        "delete": "Delete",
        "back": "Back",
        "next": "Next",
        "aria": {
            "save": "Save button",
            "cancel": "Cancel button",
            "delete": "Delete button",
            "back": "Back button"
        },
        "synchronize": "Synchronize"
    },
    "lamp": {
        "change": "Change The color",
        "brightness": "Change the Brighntess",
        "color-temp": "Change the temparature of the Color",
        "color": {
            "success": "Color successfully changed",
            "error": "Error on Color changing"
        },
        "status": {
            "success": {
                "true": "Lamp successfully opened",
                "false": "Lamp successfully closed"
            },
            "error": {
                "true": "Lamp failed to open",
                "false": "Lamp failed to close"
            }
        },
        "brighntess": {
            "success": "Brighntess successfully changed",
            "error": "Error on Brighntess changing"
        },
        "colortemp": {
            "success": "Color Temperature successfully changed",
            "error": "Error on Color Temperature changing"
        },
        "error": "Error"
    },
    "trigger": "Trigger",
    "brightness": "Brightness",
    "color": "Color",
    "color-temp": "Color Temperature",
    "mode": "Mode",
    "airflow": "Airflow",
    "temperature": "Temperature",
    "pair": "Pair",
    "occupancy-mode": "Occupancy Mode",
    "heat/setpoint/home": "Heat Setpoint (Home)",
    "heat/setpoint/away": "Heat Setpoint (Away)",
    "hot-water/trigger/home": "Hot Water Trigger (Home)",
    "hot-water/trigger/away": "Hot Water Trigger (Away)",
    "stepper": {
        "naming": "Name",
        "actions": "Actions",
        "conditions": "Conditions",
        "timings": "Time",
        "isActive": "Activity",
        "sendNotification": "Send Notifications",
        "sendEmail": "Send Email",
        "icon": "Icon",
        "add-actions": "Add Actions",
        "add-conditions": "Add Conditions",
        "add-conditions-group": "Add Conditions Group",
        "logic": "Logic",
        "operator": "Operator",
        "minutes": "Minutes",
        "value": "Value",
        "startDate": "Start Date",
        "endDate": "End Date",
        "weekdays": "Weekdays",
        "time": "Time",
        "everyNMinutes": "Every N Minutes"
    },
    "smart-tips": {
        "header": "Smart Tips and News",
        "type": "Type",
        "name": "Name",
        "title": "Title",
        "message": "Message",
        "starting-date": "Starting Date",
        "time": "Time",
        "repeat-period": "Repeat Period",
        "end-date": "End Date",
        "smart-tip": "Smart Tip",
        "news": "News",
        "select-name": "Select Name",
        "select-title": "Select Title",
        "select-message": "Select Message",
        "select-time": "Select Time",
        "once": "Once",
        "every-day": "Every Day",
        "every-week": "Every Week",
        "every-month": "Every Month",
        "fill-the-form": "Fill in the fields below"
    },
    "fields": {
        "expiration": "Expiration Date",
        "repeatPeriod": "Repeat Period",
        "validationMessage": "Please fill out the following fields: ",
        "fill-the-form": "Please fill out the following fields",
        "Type": "Type",
        "Name": "Name",
        "Notification Title": "Notification Title",
        "Notification Message": "Notification Message",
        "Start Date": "Start Date",
        "Time": "Time",
        "repeat-period": "Repeat Period",
        "end-date": "Expiration Date"
    },
    "scenesNrules": {
        "delete": "Delete Scene",
        "confirmation": "Confirm",
        "cancel": "Cancel",
        "actions": {
            "accept": "Accept",
            "reject": "Reject"
        }
    },
    "scenes": {
        "add-device": "Add Device"
    },
    "weather_conditions": {
        "Clear": "Clear sky",
        "Clouds": "Cloudy",
        "Tornado": "Tornado",
        "Ash": "Volcanic ash",
        "Dust": "Dust",
        "Sand": "Sand",
        "Fog": "Fog",
        "Haze": "Haze",
        "Smoke": "Smoke",
        "Mist": "Mist",
        "Snow": "Snow",
        "Rain": "Rain",
        "Drizzle": "Drizzle",
        "Thunderstorm": "Thunderstorm"
    },

    "general": {
        "thermostat-programm": "Thermostat Programm",
        "save": "Save",
        "reset-programm": "Reset Programm",
        "period": "Period",
        "from": "From",
        "to": "To",
        "at": "At",
        "place": "χώρος",
        "device-disconnection": "Αποσύνδεση συσκευών",
        "device-disconnection-info": "Θα ενημερώνεσαι όταν αποσυνδέεται κάποια συσκευή από τις επιλεγμένες κατηγορίες.",
        "and": "και",
        "groups": "ΟΜΑΔΕΣ",
        "devices": "Συσκευές",
        "device-lower": "συσκευή",
        "devices-lower": "συσκευές"
    },
    "rules": {
        "add-range": "Add range",
        "add-time": "Add time",
        "at": "At",
        "add-action": "+  Προσθήκη ενέργειας",
        "lum": "φωτ",
        "add-condition": "+  Προσθήκη συνθήκης",
        "info-txt": "Με τους κανόνες δεν χρειάζεται να ανησυχείς για τίποτα! Το Smarthink Θα εκτελεί αυτόματα τις ενέργειες που έχεις ορίσει.",
        "select-condition": "Επιλογή Συνθήκης",
        "time": "Χρονική στιγμή",
        "time-info": "Θέλω ο κανόνας να εκτελείται μία συγκεκριμένη ώρα.",
        "all-days": "Κάθε μέρα",
        "schedule": "ΔΙΑΣΤΗΜΑ ΗΜΕΡΑΣ",
        "processing-option": "Επεξεργασία κανόνα",
        "copy-option": "Δημιουργία αντιγράφου",
        "delete-option": "Διαγραφή κανόνα",
        "new": "Νέος κανόνας",
        "settings-rules": "ΡΥΘΜΙΣΕΙΣ ΚΑΝΟΝΑ",
        "time-schedule": "ΧΡΟΝΟΠΡΟΓΡΑΜΜΑΤΙΣΜΟΣ",
        "when": "Όταν",
        "when-text": "συμβεί οποιοδήποτε από τα παρακάτω:",
        "and-if": "και εφόσον",
        "and-if-text": "ισχύει οτιδήποτε από τα παρακάτω (προαιρετικό)",
        "then": "τότε",
        "then-text": "θα εκτελούνται οι παρακάτω ενέργειες:",
        "choose": "Διάλεξε πότε θα εκτελείται ο κανόνας:",
        "temperature": "Θερμοκρασία, υγρασία, φωτεινότητα",
        "temperature-text": "Θέλω ο κανόνας να εκτελείται εφόσον ένας αισθητήρας έχει μια τιμή.",
        "detect": "Ανίχνευση κίνησης",
        "detect-text": "Θέλω ο κανόνας να εκτελείται όταν ανιχνευθεί κίνηση.",
        "doorwindowsensor": "Άνοιγμα/Κλείσιμο παγίδας",
        "doorwindowsensor-text": "Θέλω ο κανόνας να εκτελείται εφόσον μια παγίδα είναι κλειστή ή ανοιχτή.",
        "choose-actions": "Επίλεξε ποιες ενέργειες θα εκτελούνται όταν τρέχει ο κανόνας:",
        "device": "Συσκευή",
        "change-settings": "θέλω να αλλάζουν οι ρυθμίσεις συσκεών π.χ να κλείνουν τα φώτα.",
        "scene": "Σενάριο",
        "activate-scene": "Θέλω να εκτελείται ένα έτοιμο σενάριο.",
        "notification": "Ειδοποίηση",
        "send-notification": "Θέλω να μου αποστέλλεται μια ειδοποίηση.",
        "select-notification": "Επιλογή ειδοποίησης",
        "choose-notification": "Επίλεξε τι είδους ειδοποίηση θέλεις να λαμβάνεις",
        "send-push": "Αποστολή push notification στο κινητό μου.",
        "email": "Email",
        "send-email": "Αποστολή email στην ηλεκτρονική μου διεύθυνση.",
        "select-scene": "Διάλεξε ποιο σενάριο θέλεις να εκτελείται με τον κανόνα.",
        "select-info": "Διάλεξε ποια συσκευή ή ομάδα θέλεις να συμμετέχει στον κανόνα.",
        "action": "Όρισε ποιά ενέργεια θέλεις να εκτελείται με τον κανόνα.",
        "select-device": "Επιλογή κατηγορίας συσκευής",
        "used": "Το σενάριο εκτελέστηκε επιτυχώς",
        "added": "Προστέθηκε στην Επισκόπηση",
        "send-option": "Αποστολή στην επισκόπηση",
        "deleted": "Ο κανόνας διαγράφηκε",
        "copy": "Δημιουργήθηκε αντίγραφο επιτυχώς",
        "created": "O κανόνας δημιουργήθηκε επιτυχώς",
        "trigger-deleted": "Το trigger διαγράφηκε",
        "condition-deleted": "Η συνθήκη διαγράφηκε",
        "action-deleted": "Η ενέργεια διαγράφηκε",
        "rule-error": "Δεν ήταν δυνατή η δημιουργία Κανόνα",
        "rule-activated": "Ο κανόνας ενεργοποιήθηκε",
        "rule-inactive": "Ο κανόνας απενεργοποιήθηκε",
        "updated": "Έγινε ενημέρωση του κανόνα επιτυχώς",
        "email-send": "Αποστολή email",
        "notification-send": "Αποστολή ειδοποίησεων",
        "email-notification-send": "Αποστολή email & ειδοποίησης"
    },

    "usersettings": {
        "actions": {
            "reject": "Reject",
            "accept": "Accept"
        }
    },

    "AutoSavings": "Auto Savings",
    "SmartTips": "Smart Tips",
    "SmartRecommendations": "Smart Recommendations",
    "ReceiveConsumptionStatistics": "Receive Consumption Statistics",
    "NewsOffers": "News & Offers",
    "Thermostat": "Thermostat",
    "EnergyMeter": "Energy Meter",
    "SmartPlug": "Smart Plug",
    "Lamp": "Lamp",
    "DoorSensor": "Door Sensor",
    "AreaSensor": "Area Sensor",
    "household-info": "Household Information",
    "submit": "Submit",
    "change-icon": "Change Icon",
    "add-icon": "Add Icon",
    "on": "Άνοιγμα",
    "off": "Κλείσιμο",
    "Cool": "Ψύξη",
    "Auto": "Αυτόματο",
    "Heat": "Θέρμανση",
    "Fanonly": "Ανεμιστήρας",
    "Dry": "Ξερός",
    "hot-water": "Zεστό νερό",
    "Devices": "Devices"
}
